/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Features_Effects_TitleInputs */

const en_fc_home_features_effects_title = /** @type {(inputs: Fc_Home_Features_Effects_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effects and keyframes`)
};

/**
* | output |
* | --- |
* | "Effects and keyframes" |
*
* @param {Fc_Home_Features_Effects_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_features_effects_title = /** @type {((inputs?: Fc_Home_Features_Effects_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Features_Effects_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_features_effects_title(inputs)
});
export { fc_home_features_effects_title as "fc.home.features.effects.title" }